// src/App.js
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout';

// Sider
import { Home } from './Pages/Home';
import { About } from './Pages/About';
import { Tjenester } from './Pages/tjenester';
import { Contact } from './Pages/Contact';
import { Prices } from './Pages/Prices';
import { LoginSignUp } from './Pages/LoginSignUp';
import { Portefølje } from './Pages/Portefølje';
import { ProjectDetails } from './Pages/ProjectDetails';
import { Vilkaar } from './Pages/vilkaar';
import { WarningTermsPage } from './Pages/TermsAndCond';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/om" element={<About />} />
          <Route path="/tjenester" element={<Tjenester />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/priser" element={<Prices />} />
          <Route path="/login" element={<LoginSignUp />} />
          <Route path="/portefølje" element={<Portefølje />} />
          <Route path="/projekt/:id" element={<ProjectDetails />} />
          <Route path="/vilkaar" element={<Vilkaar />} />
          <Route path="/vilkaar-engelsk" element={<WarningTermsPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;